import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmartEdit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11.5001 4L11.0001 3L10.5001 4L9.50006 4.125L10.3341 4.833L10.0001 6L11.0001 5.334L12.0001 6L11.6661 4.833L12.5001 4.125L11.5001 4ZM19.8341 14.666L19.0001 13L18.1661 14.666L16.5001 14.875L17.8891 16.056L17.3341 18L19.0001 16.889L20.6661 18L20.1111 16.056L21.5001 14.875L19.8341 14.666ZM7.16706 6.333L6.50006 5L5.83306 6.333L4.50006 6.5L5.61106 7.444L5.16706 9L6.50006 8.111L7.83306 9L7.38906 7.444L8.50006 6.5L7.16706 6.333ZM3.91406 17C3.91406 17.534 4.12206 18.036 4.50006 18.414L6.08606 20C6.46406 20.378 6.96606 20.586 7.50006 20.586C8.03406 20.586 8.53606 20.378 8.91406 20L20.5001 8.414C20.8781 8.036 21.0861 7.534 21.0861 7C21.0861 6.466 20.8781 5.964 20.5001 5.586L18.9141 4C18.1581 3.244 16.8421 3.244 16.0861 4L4.50006 15.586C4.12206 15.964 3.91406 16.466 3.91406 17ZM17.5001 5.414L19.0861 7L15.5001 10.586L13.9141 9L17.5001 5.414Z",
		fill: "#363F5A"
	})]
});
const ForwardRef = forwardRef(SvgSmartEdit);
export default ForwardRef;
